export default __webpack_public_path__ + "static/media/Asterisk.3abca5a4.svg";